/** @jsxImportSource theme-ui */
import * as React from "react";
// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details
import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import {
  NessieFunctionComponent,
  NessieComponentProps,
  colorNessieResponsivePropType,
  oneOfNessieResponsivePropType,
} from "../../propTypes";
import { NessieThemeColors } from "../../theme";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
type HomeIconProps = React.SVGProps<SVGSVGElement> &
  NessieComponentProps & {
    size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
    color?: NessieThemeColors;
    onClick?: () => void;
    cursor?: React.CSSProperties["cursor"];
    display?: React.CSSProperties["display"];
    "data-test-name"?: string;
    "aria-label"?: string;
  };

let HomeIcon: NessieFunctionComponent<HomeIconProps> = ({
  size = "m",
  color = "shale",
  onClick,
  cursor,
  display = "inline-block",
  ["data-test-name"]: dataTestName,
  ["aria-label"]: ariaLabel,
  ...props
}) => {
  const sizeInPixels = SIZES[size];
  const ButtonOrSpan = onClick ? UnstyledButton : "span";
  return (
    <ButtonOrSpan
      aria-label={ariaLabel}
      data-test-name={dataTestName}
      onClick={onClick}
      sx={{
        fontSize: sizeInPixels,
        display,
        lineHeight: 0,
        color,
        cursor,
        position: "relative",
      }}
    >
      {
        <svg
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.42 10.726L12.6 3.271c-.4-.361-1.002-.361-1.403 0L2.38 10.726c-.44.4-.52 1.082-.12 1.523.4.441 1.082.521 1.523.12l.16-.12v8.578c0 .36.321.681.682.681h4.97v-7.415h4.65v7.415h4.97c.36 0 .681-.32.681-.681v-8.578l.16.12a1.088 1.088 0 001.524-.16c.36-.44.32-1.122-.16-1.483z"
          />
          <mask maskUnits="userSpaceOnUse" x={2} y={3} width={20} height={19}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.42 10.726L12.6 3.271c-.4-.361-1.002-.361-1.403 0L2.38 10.726c-.44.4-.52 1.082-.12 1.523.4.441 1.082.521 1.523.12l.16-.12v8.578c0 .36.321.681.682.681h4.97v-7.415h4.65v7.415h4.97c.36 0 .681-.32.681-.681v-8.578l.16.12a1.088 1.088 0 001.524-.16c.36-.44.32-1.122-.16-1.483z"
            />
          </mask>
        </svg>
      }
    </ButtonOrSpan>
  );
};

const SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px",
};
HomeIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"]),
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  HomeIcon = nessiePropCheckerWrapper(HomeIcon);
}

export default HomeIcon;
